import React from 'react';
import ParentLayout from './ParentLayout';
import useRouter from '../../../hooks/useRouter';
import Project from '../../projects/Project';
import useQuery from './useQuery';
import NetworkSite from '../../sites/NetworkSite';
import useNetwork from '../../../hooks/useNetwork';
import LocationMap from './LocationMap';
import Card from '../../../components/Card';
import classNames from 'classnames';

export default function Layout(props) {
  const { location } = useRouter();

  const network = useNetwork();

  const PAGE_SIZE = 1000;

  const result = useQuery({
    location,
    PAGE_SIZE
  });

  return (
    <ParentLayout
      breadcrumbs={['Explore', 'Sites']}
      title="Map"
      description={(
        <span>
          This page shows all sites in your network.
        </span>
      )}
      pageSize={PAGE_SIZE}
      result={result}
      row={function(site) {
        return (
          <Card
            key={site.id}
            rounded={false}
            className={classNames(
              'rounded-cs-10',
              'p-4 space-y-3'
            )}
          >
            <div className="w-full h-32 opacity-70 rounded-cs-10 overflow-hidden">
              <LocationMap
                location={site}
                cursor="arrow"
              />
            </div>
          </Card>
        );
        // return (
        //   <NetworkSite
        //     key={site.id}
        //     network={network}
        //     site={site}
        //   />
        // );
      }}
    />
  );
}
